import { render, staticRenderFns } from "./RepairClass.vue?vue&type=template&id=2310d9f7"
import script from "./RepairClass.vue?vue&type=script&lang=js"
export * from "./RepairClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports